import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { darkGrayFontColor, titles, white } from '../../../web/styles/colors';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	dateButtonGroup: {
		width: 'inherit',
	},
	dateButton: {
		justifyContent: 'space-between',
		color: darkGrayFontColor,
		':hover': {
			color: darkGrayFontColor,
		},
		flex: 1,
	},
	dateButtonActive: {
		color: titles,
		':hover': {
			color: titles,
		},
	},
	clearFiltersButton: {
		alignSelf: 'flex-end',
	},
	filter: {
		marginBottom: spacing.md + spacing.xs,
		display: 'grid',
		gap: spacing.sm,
		gridTemplateColumns: 'repeat(auto-fill, minmax(min(272px, 100%), 1fr))',
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	label: {
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
	},
	tabsContainer: {
		display: 'flex',
		borderBottom: `1px solid ${colors.border.main}`,
		marginBottom: spacing.md + spacing.xs,
	},
	tab: {
		borderBottom: '3px solid transparent',
		cursor: 'pointer',
		padding: `${spacing.sm}px ${spacing.md}px`,
		fontSize: typography.fontSizes.sm,
		fontWeight: 500,
	},
	tabActive: {
		borderBottomColor: colors.secondary.main,
	},
	pageRoot: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	pageContent: {
		width: '100%',
		minHeight: 0,
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		borderTopLeftRadius: 16,
	},
	// Layout styles for full-page scrolling (replacing LeadViewRowElement styles)
	demosLayoutContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column' as const,
		// NO height: 100% or overflowY: hidden - allows content to flow
	},
	demosLayoutContainerInner: {
		width: '100%',
		maxWidth: 1400,
		overflowX: 'hidden' as const,
		margin: '0 auto',
		paddingRight: 16,
		paddingLeft: 16,
		paddingBottom: 16,
		marginTop: 16,
		// NO flex: 1 - allows natural height
	},
	demosLayoutContent: {
		display: 'flex',
		flexDirection: 'column' as const,
		padding: 24,
		borderRadius: 8,
		backgroundColor: white,
		color: colors.text.dark,
		// NO height: 100% or flex: 1
	},
	demosLayoutHeader: {
		marginBottom: 24,
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 8,
	},
	demosLayoutTitle: {
		fontSize: 24,
		fontWeight: 'bold' as const,
	},
	// Override for DataboardBody to disable internal scrolling
	databoardBodyOverride: {
		overflow: 'visible',
		height: 'auto',
	},
});
